import { createFileRoute } from '@tanstack/react-router'
import KonzeptPage from '@/spa/pages/KonzeptPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/konzept')({
  component: KonzeptPage,
  errorComponent: routeErrorComponent,
})
